import React from "react";
import $ from "jquery";
import $events from '../../../blocs/EventBloc';

export default class TutorialOverlayStep1 extends React.Component {
    constructor( props ) {
        super(props);
        this.spotlightContainer = React.createRef();
        this.spotlightTooltip   = React.createRef();
    }

    positionTooltip = ( $spot ) => {
        let offsetRight = $spot.offset().left + $spot.width();

        $(this.spotlightTooltip.current).css({
            left:   offsetRight + 30,
            top:     $spot.offset().top,
            opacity: 1
        });
    }

    hideTooltip() {
        $(this.spotlightTooltip.current).css({
            opacity: 0
        });
    }

    componentDidMount() {
        $events.$on('swipescreen/detectSpot', ( $spot ) => {
            console.log("detect spot tutorial", $spot);
            if ( $spot.index === 0 ) {
                this.positionTooltip($spot);
            }
        });

        $events.$on('swipescreen/lostSpot', ( $spot ) => {
            console.log("lost spot tutorial", $spot);
            if ( $spot.index === 0 ) {
                this.hideTooltip();
            }
        });
    }

    componentWillUnmount() {
        $events.$off('swipescreen/detectSpot');
        $events.$off('swipescreen/lostSpot');
    }

    render() {
        return (
            <div className="tutorial-area  tutorial-area__step1">
                {this.props.tutorialState.swipeLearned === false &&
                <div className="instruction-info  [ wow fadeInUp ]  [ margin__bottom--small ]">
                    <div className="instruction-info__icon">
                        <svg viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g fill="currentColor">
                                <path
                                    d="M18.0612 7.57765C17.5694 7.51059 17.1223 7.71177 16.8317 8.02471C16.6753 7.39883 16.1165 6.95176 15.4682 6.95176C15.0435 6.95176 14.6635 7.15294 14.3953 7.46588C14.2165 6.90706 13.68 6.48235 13.0541 6.48235C12.6741 6.48235 12.3165 6.63883 12.0482 6.90706V1.58706C12.0482 0.871762 11.5341 0.223527 10.8188 0.134116C9.96941 0.0223511 9.23176 0.692941 9.23176 1.52V11.02C9.23176 11.1988 8.98588 11.2882 8.87411 11.1318L7.24235 8.65059C6.86235 8.06941 6.01294 7.9353 5.3647 8.36C4.71647 8.78471 4.49294 9.61175 4.8953 10.1929C4.8953 10.1929 9.47764 17.1223 9.49999 17.1447C10.3271 18.307 11.6682 19 13.1435 19H14.7753C17.2341 19 19.2459 17.0329 19.2682 14.5965C19.2682 14.5741 19.2682 14.5294 19.2682 14.5071V9.05294C19.2682 8.31529 18.7541 7.66706 18.0612 7.57765Z"/>
                                <path
                                    d="M7.89058 1.76589C7.89058 1.45295 7.6447 1.20706 7.33175 1.20706H2.57059V0.447058C2.57059 0.268235 2.45882 0.111767 2.30235 0.0447086C2.23529 0.0223556 2.16823 0 2.12353 0C2.01176 0 1.92235 0.0447058 1.83294 0.111765L0.156473 1.54236C0.0447086 1.63177 0 1.76588 0 1.9C0 2.03412 0.067056 2.16823 0.178821 2.23529L1.85529 3.44235C1.98941 3.53177 2.16824 3.55411 2.32471 3.48705C2.48118 3.41999 2.57059 3.24118 2.57059 3.06235V2.34706H7.33175C7.6447 2.34706 7.89058 2.07883 7.89058 1.76589Z"/>
                                <path
                                    d="M21.0788 1.54236L19.4023 0.111765C19.3129 0.0447058 19.2235 0 19.1117 0C19.0447 0 18.9776 0.0223556 18.9329 0.0447086C18.7765 0.111767 18.6647 0.268235 18.6647 0.447058V1.20706H13.9035C13.5906 1.20706 13.3447 1.45295 13.3447 1.76589C13.3447 2.07883 13.5906 2.32471 13.9035 2.32471H18.6647V3.06235C18.6647 3.24118 18.7541 3.39764 18.9106 3.48705C19.067 3.55411 19.2459 3.55412 19.38 3.44235L21.0565 2.23529C21.1682 2.14588 21.2353 2.03412 21.2353 1.9C21.2353 1.76588 21.1906 1.63177 21.0788 1.54236Z"/>
                            </g>
                        </svg>
                    </div>

                    <div className="instruction-info__text">
                        Nach rechts oder links wischen <br/>
                        und den Raum erkunden
                    </div>
                </div>}

                <div
                    className={`instruction-info  [ spotlight-tooltip ]  ${( this.props.tutorialState.swipeLearned === true ) ? 'is--visible' : ''}`}
                    ref={this.spotlightTooltip}>
                    <div className="instruction-info__icon">
                        <svg viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g fill="currentColor">
                                <path
                                    d="M17.6743 16.1139C17.0692 16.0183 16.5278 16.2731 16.1457 16.6871C15.9546 15.9228 15.2859 15.3496 14.4579 15.3496C13.9165 15.3496 13.4388 15.6043 13.1204 15.9865C12.8974 15.2859 12.2287 14.7764 11.4644 14.7764C10.9867 14.7764 10.5409 14.9674 10.2224 15.2859L10.2224 8.69383C10.2224 7.80216 9.58551 7.00602 8.72568 6.91049C7.67478 6.7831 6.75125 7.61108 6.75125 8.63014L6.75125 20.3812C6.75125 20.6041 6.4328 20.6996 6.30542 20.5086L4.2673 17.4514C3.78961 16.7189 2.73871 16.5597 1.94257 17.1011C1.14643 17.6424 0.859814 18.6615 1.3375 19.3621C1.3375 19.3621 7.00602 27.9286 7.03787 27.9923C8.05692 29.4253 9.74474 30.2851 11.5599 30.2851L13.5662 30.2851C16.5915 30.2851 19.1073 27.8649 19.1392 24.8077C19.1392 24.7759 19.1392 24.744 19.1392 24.6803L19.1392 17.9291C19.171 17.0055 18.5341 16.2094 17.6743 16.1139Z"/>
                                <path
                                    d="M8.47094 4.42654C8.88493 4.42654 9.23524 4.07623 9.23524 3.66224L9.23524 0.764295C9.23524 0.350302 8.88493 -7.42337e-06 8.47094 -7.49576e-06C8.05694 -7.56814e-06 7.70663 0.350302 7.70663 0.764294L7.70663 3.66224C7.70663 4.07623 8.05694 4.42654 8.47094 4.42654Z"/>
                                <path
                                    d="M4.52208 5.60481C4.6813 5.76404 4.87238 5.82773 5.06345 5.82773C5.25453 5.82773 5.44561 5.76404 5.60483 5.60481C5.89144 5.3182 5.89144 4.80868 5.60483 4.52207L3.56671 2.48394C3.2801 2.19733 2.77058 2.19733 2.48397 2.48394C2.19736 2.77055 2.19736 3.28009 2.48397 3.5667L4.52208 5.60481Z"/>
                                <path
                                    d="M4.42653 8.47091C4.42653 8.05692 4.07624 7.70663 3.66224 7.70663L0.764283 7.70663C0.35029 7.70663 -6.12466e-08 8.05692 -1.33631e-07 8.47091C-2.06016e-07 8.8849 0.35029 9.23521 0.764282 9.23521L3.66224 9.23521C4.07624 9.23521 4.42653 8.8849 4.42653 8.47091Z"/>
                                <path
                                    d="M12.5153 8.47091C12.5153 8.88491 12.8656 9.23522 13.2796 9.23522L16.1775 9.23522C16.5915 9.23522 16.9418 8.88491 16.9418 8.47091C16.9418 8.05692 16.5915 7.70663 16.1775 7.70663L13.2796 7.70663C12.8656 7.70663 12.5153 8.05692 12.5153 8.47091Z"/>
                                <path
                                    d="M11.8784 5.82773C12.0695 5.82773 12.2606 5.76404 12.4198 5.60481L14.4579 3.5667C14.7445 3.28009 14.7445 2.77055 14.4579 2.48394C14.1713 2.19733 13.6618 2.19733 13.3752 2.48394L11.337 4.52207C11.0504 4.80868 11.0504 5.3182 11.337 5.60481C11.4644 5.76404 11.6873 5.82773 11.8784 5.82773Z"/>
                            </g>
                        </svg>
                    </div>

                    <div className="instruction-info__text"
                         dangerouslySetInnerHTML={{__html: this.props.roomState.room.tutorial_fields?.tooltip_text ?? 'Tippe auf einen Info-Punkt,<br/>um mehr über ihn zu erfahren.'}}>
                    </div>
                </div>
            </div>
        );
    }

}
